import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../../Store';
import ModuleRectangleSettings, { Props } from '../_components/ModuleRectangleSettings';
import { ColorResult } from 'react-color';
import { ModuleOnValueUpdate } from '../../_actions/ModuleActions';

// Module has no need for a container but use this file nonetheless for consistency
export default ModuleRectangleSettings;